import { useAvailableBumbalDates } from "app/hooks/checkout/useAvailableBumbalDates";
import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import { Dispatch, SetStateAction, useState } from "react";
import { AvailableBumbalDate } from "shared/api/middleware-api-client";
import FormGroup from "shared/ui/FormGroup";
import Radio, { RadioVariant } from "shared/ui/radio";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import Bumbal from "widgets/shared/bumbal";

interface CheckoutAppointmentTypeProps {
  className?: string;
  selectedDate: Date | null;
  setSelectedDate: Dispatch<SetStateAction<Date | null>>;
  planAppointmentLater: boolean;
  setPlanAppointmentLater: Dispatch<SetStateAction<boolean>>;
}

const NOW_APPOINTMENT_TITLE_MAPPING: Record<string, string> = {
  shipment: "Plan direct een gratis afleverafspraak in",
  measurement: "Plan direct een gratis inmeetafspraak in",
};

const CheckoutAppointmentType = ({
  className,
  setSelectedDate,
  selectedDate,
  planAppointmentLater,
  setPlanAppointmentLater,
}: CheckoutAppointmentTypeProps) => {
  const { order, type } = useOrderContext();
  const {
    isBumbalDataLoading,
    isBumbalDataFetching,
    bumbalData,
    fetchAmount,
    bumbalDates,
    setPageMonth,
    setPageYear,
  } = useAvailableBumbalDates();
  const { isSampleSale } = useCartContext();

  const radioText = order?.isZakelijkOrder
    ? "Plan direct een bezorgafspraak in"
    : isSampleSale || order?.isSelfAssembly
      ? "Plan direct een afleverafspraak in"
      : NOW_APPOINTMENT_TITLE_MAPPING[type];

  // TODO: Extract this to provider
  const [inputType, setInputType] = useState<string>("hover");
  const [disableBumbalWidget, setDisableBumbalWidget] = useState(false);

  const renderBumbalWidget = (
    dates: AvailableBumbalDate[],
    refetchDates: any,
    selectedDate: Date | null,
    setSelectedDate: Dispatch<SetStateAction<Date | null>>,
    refetchAmount: number,
  ) => {
    return (
      <div className="">
        {bumbalData && (
          <Bumbal
            refetchDates={refetchDates}
            slots={dates || "joe"}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            refetchAmount={refetchAmount}
            disabled={disableBumbalWidget}
            isBumbalDataLoading={isBumbalDataLoading}
            isBumbalDataFetching={isBumbalDataFetching}
          />
        )}
      </div>
    );
  };

  // TODO: extact this function into a hook or provider
  /**
   * It sets the pageMonth, pageYear, and inputType state variables.
   * @param {number} month - The month you want to fetch dates for.
   * @param {number} year - The year of the calendar you want to display.
   * @param {string} type - string - This is the type of input you want to use. It can be either 'single' or 'range'.
   */
  const fetchDates = (month: number, year: number, type: string) => {
    setPageMonth(month);
    setPageYear(year);
    setInputType(type);
  };

  return (
    <section
      className={concatClassnames(
        "gg-pt-14",
        className,
        !isSampleSale && "gg-pb-14",
      )}
    >
      <FormGroup
        className={concatClassnames(
          "gg-mb-14",
          "gg-grid",
          "gg-gap-y-5",
          planAppointmentLater
            ? "gg-opacity-50 gg-grayscale gg-transition-opacity"
            : "",
        )}
      >
        <Radio
          checked={!planAppointmentLater}
          variant={RadioVariant.CIRCLE}
          name="plan_appointment"
          id="plan_now"
          onChange={(e) => {
            setDisableBumbalWidget(!e.target.checked);
            setPlanAppointmentLater(false);
          }}
        >
          <Heading headingLevel="h5">{radioText}</Heading>
        </Radio>
        {/* TODO: Extract this to provider */}
        <div>
          {bumbalData && (
            <Bumbal
              refetchDates={isBumbalDataLoading ? () => {} : fetchDates}
              slots={isBumbalDataLoading ? [] : bumbalDates || []}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              refetchAmount={fetchAmount}
              disabled={disableBumbalWidget}
              isBumbalDataFetching={isBumbalDataFetching}
              isBumbalDataLoading={isBumbalDataLoading}
            />
          )}
        </div>
      </FormGroup>

      {type !== "shipment" ? (
        <FormGroup
          className={
            !planAppointmentLater
              ? "gg-opacity-50 gg-grayscale gg-transition-opacity"
              : ""
          }
        >
          <Radio
            checked={planAppointmentLater}
            variant={RadioVariant.CIRCLE}
            onChange={(e) => {
              setSelectedDate(null);
              setDisableBumbalWidget(true);
              setPlanAppointmentLater(true);
            }}
            name="plan_appointment"
            id="plan_later"
          >
            <Heading headingLevel="h5">Op een later moment</Heading>
          </Radio>

          <Text className="gg-col-span-12 gg-mt-5">
            Weet je nog niet wanneer het inmeten kan plaatsvinden? Dat is geen
            probleem, wij sturen je een e-mail waarmee je op ieder gewenst
            moment alsnog je afspraak kunt vastleggen. Bewaar deze e-mail dus
            goed!
          </Text>
        </FormGroup>
      ) : (
        <></>
      )}
    </section>
  );
};
export default CheckoutAppointmentType;
